import { z } from 'zod';
import { isoDateSchema, isoDateTimeSchema, uuidSchema } from './common.js';
/**
 * Payroll as the books see it: one run per pay date, gross, deductions, net,
 * and the employer's share. Money is a string of cents throughout.
 */
export const PAYROLL_RUN_STATUSES = ['draft', 'posted', 'void'];
export const payrollRunStatusSchema = z.enum(PAYROLL_RUN_STATUSES);
const minor = z.string().regex(/^-?\d{1,15}$/);
export const payrollLineSchema = z.object({
    id: uuidSchema,
    lineNumber: z.number().int(),
    employeeName: z.string(),
    technicianId: uuidSchema.nullable(),
    grossMinor: minor,
    cppMinor: minor,
    eiMinor: minor,
    taxMinor: minor,
    otherMinor: minor,
    netMinor: minor,
    employerCppMinor: minor,
    employerEiMinor: minor,
    employerOtherMinor: minor,
});
export const payrollRunSchema = z.object({
    id: uuidSchema,
    status: payrollRunStatusSchema,
    payDate: isoDateSchema,
    periodStart: isoDateSchema.nullable(),
    periodEnd: isoDateSchema.nullable(),
    memo: z.string().nullable(),
    /** The register it was read from, when it was. */
    documentId: uuidSchema.nullable(),
    readingStatus: z.enum(['balanced', 'unbalanced']).nullable(),
    readingFailure: z.string().nullable(),
    grossMinor: minor,
    cppMinor: minor,
    eiMinor: minor,
    taxMinor: minor,
    otherMinor: minor,
    netMinor: minor,
    employerCppMinor: minor,
    employerEiMinor: minor,
    employerOtherMinor: minor,
    journalEntryId: uuidSchema.nullable(),
    postedAt: isoDateTimeSchema.nullable(),
    voidReason: z.string().nullable(),
    createdAt: isoDateTimeSchema,
    lines: z.array(payrollLineSchema),
});
const cents = z.string().regex(/^\d{1,13}$/);
export const savePayrollRunRequestSchema = z.object({
    payDate: isoDateSchema,
    periodStart: isoDateSchema.nullable().optional(),
    periodEnd: isoDateSchema.nullable().optional(),
    memo: z.string().trim().max(500).nullable().optional(),
    lines: z
        .array(z.object({
        employeeName: z.string().trim().min(1).max(200),
        technicianId: uuidSchema.nullable().optional(),
        grossMinor: cents,
        cppMinor: cents.default('0'),
        eiMinor: cents.default('0'),
        taxMinor: cents.default('0'),
        otherMinor: cents.default('0'),
        /** Left out, the employer's CPP matches the employee's and EI is 1.4 times. */
        employerCppMinor: cents.nullable().optional(),
        employerEiMinor: cents.nullable().optional(),
        employerOtherMinor: cents.default('0'),
    }))
        .min(1)
        .max(500),
});
export const payrollLiabilitiesSchema = z.object({
    /** Owed to the CRA: employee CPP, EI and tax plus the employer's CPP and EI. */
    sourceDeductionsMinor: minor,
    /** Net pay posted but not yet seen leaving the bank. */
    netPayOwedMinor: minor,
    otherMinor: minor,
});
//# sourceMappingURL=payroll.js.map